import { render, staticRenderFns } from "./AbkMatchIndicator.vue?vue&type=template&id=1cf3b802&scoped=true&"
import script from "./AbkMatchIndicator.vue?vue&type=script&lang=js&"
export * from "./AbkMatchIndicator.vue?vue&type=script&lang=js&"
import style0 from "./AbkMatchIndicator.vue?vue&type=style&index=0&id=1cf3b802&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1cf3b802",
  null
  
)

export default component.exports